export const LOADER_METRICA_POR_COMPETENCIA          =       'LOADER_METRICA_POR_COMPETENCIA';
export const GET_METRICA_POR_COMPETENCIA             =       'GET_METRICA_POR_COMPETENCIA';
export const METRICA_POR_COMPETENCIA_FALLA           =       'METRICA_POR_COMPETENCIA_FALLA';
export const SAVE_LOADER_METRICA_POR_COMPETENCIA     =       'SAVE_LOADER_METRICA_POR_COMPETENCIA';
export const FORM_METRICA_POR_COMPETENCIA_FAIL       =       'FORM_METRICA_POR_COMPETENCIA_FAIL';
export const GET_ULTIMO_REGISTRO                     =       'GET_ULTIMO_REGISTRO';
export const LOADER_ULTIMO_REGISTRO                  =       'LOADER_ULTIMO_REGISTRO';


